import styled from 'styled-components';

const DistributorsSectionStyle = styled.section`
	--runningTextMTop: var(--sp45x);
	--btnMTop: var(--sp11x);
	--mapImageHeight: 43.4%;

	margin-bottom: var(--sectionDistance);

	.ds-title {
		margin-bottom: var(--subSectionDistance);
	}

	.ds-map-wrapper {
		.image-cont {
			padding-top: var(--mapImageHeight);
		}

		.absolute-wrapper {
			position: absolute;
			top: 0;
			left: 0;

			.running-text {
				margin-top: var(--runningTextMTop);
			}
		}
	}

	.m-btn-wrap {
		display: flex;
		justify-content: center;
		margin-top: var(--btnMTop);

		.anim-btn-cont {
			&:before {
				background-color: var(--primaryColor1) !important;
			}
		}

		.anim-btn-icon-cont {
			i {
				&:before {
					color: var(--primaryColor1) !important;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--btnMTop: var(--sp8x);
		--mapImageHeight: 43.3%;
		--runningTextMTop: var(--sp33x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--btnMTop: var(--sp7x);
		--mapImageHeight: 43.1%;
		--runningTextMTop: var(--sp34x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--btnMTop: var(--sp6x);
		--mapImageHeight: 43.9%;
		--runningTextMTop: var(--sp25x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--btnMTop: var(--sp6x);
		--mapImageHeight: 44%;
		--runningTextMTop: var(--sp22x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--btnMTop: var(--sp5x);
		--mapImageHeight: 43.7%;
		--runningTextMTop: var(--sp18x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--btnMTop: var(--sp5x);
		--mapImageHeight: 42.2%;
		--runningTextMTop: var(--sp15x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--btnMTop: var(--sp4x);
		--mapImageHeight: 42.3%;
		--runningTextMTop: var(--sp7x);
	}
`;

export default DistributorsSectionStyle;
